package br.com.vvrefeicoes.portal.core.util

import kotlinx.browser.document
import org.w3c.dom.HTMLElement

actual fun savePdf(
    fileName: String,
    base64: String,
): Boolean {
    val anchor = document.createElement("a")
    anchor.setAttribute("href", "data:application/pdf;base64,$base64")
    anchor.setAttribute("download", fileName)
    (anchor as HTMLElement).click()
    return true
}

actual fun isPdfExportSupported(): Boolean = true
